import { render, staticRenderFns } from "./InventoryPacking.vue?vue&type=template&id=7ffee4e0&scoped=true"
import script from "./InventoryPacking.vue?vue&type=script&lang=js"
export * from "./InventoryPacking.vue?vue&type=script&lang=js"
import style0 from "./InventoryPacking.vue?vue&type=style&index=0&id=7ffee4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffee4e0",
  null
  
)

export default component.exports